/**
 * usePermissions Hook
 * 
 * Provides easy access to user permissions based on their role.
 * Usage:
 *   const { canCreateEstimates, canManageUsers, permissions } = usePermissions();
 */

import { useCompanyMembership } from '../contexts/CompanyMembershipContext';

export function usePermissions() {
  const { permissions, currentUserRole, isLoading } = useCompanyMembership();

  // If no permissions loaded yet, return safe defaults (all false)
  const safePermissions = permissions || {
    canManageSettings: false,
    canManageUsers: false,
    canManageBilling: false,
    canViewCustomers: false,
    canCreateCustomers: false,
    canEditCustomers: false,
    canDeleteCustomers: false,
    canViewEstimates: false,
    canCreateEstimates: false,
    canEditEstimates: false,
    canDeleteEstimates: false,
    canApproveEstimates: false,
    canViewJobs: false,
    canCreateJobs: false,
    canEditJobs: false,
    canDeleteJobs: false,
    canViewAllJobs: false,
    canViewSchedule: false,
    canEditSchedule: false,
    canAssignWork: false,
    canViewInventory: false,
    canEditInventory: false,
    canManagePickLists: false,
    canViewAnalytics: false,
    canViewAllAnalytics: false,
  };

  return {
    ...safePermissions,
    permissions: safePermissions,
    role: currentUserRole,
    isLoading,
    isAdmin: currentUserRole === 'admin',
    isManager: currentUserRole === 'manager',
    isEstimator: currentUserRole === 'estimator',
    isTech: currentUserRole === 'tech',
    isOffice: currentUserRole === 'office',
  };
}

